// FILE: src/utils/firebase/features/tags/fetchers.js

import { fetchByEmailOnce, subscribeByEmailHelper } from "../../core/emailScoped";
import { COLLECTIONS } from "../../core/collections";
import { getOrFetch, getOrFetchWithMeta, invalidate as _invalidate } from "../../cache/getOrFetch";

/* ---------- TTLs ---------- */
const TTL_USER_TAGS = Number(process.env.REACT_APP_TTL_USER_TAGS_MS) || 60 * 60 * 1000; // 1h

export function subscribeUserTags({ userEmail, cap = 1000, onData, onError }) {
  return subscribeByEmailHelper({
    colName: COLLECTIONS.userTags,
    userEmail,
    cap,
    extra: [],
    onData,
    onError,
  });
}

export function fetchUserTagsOnce(userEmail, opts = {}) {
  if (opts?.noCache) return fetchByEmailOnce(COLLECTIONS.userTags, userEmail, opts);
  const key = `tags:${userEmail}`;
  return getOrFetch({
    key,
    ttlMs: opts.ttlMs ?? TTL_USER_TAGS,
    persist: true,
    persistKey: key,
    fetcher: () => fetchByEmailOnce(COLLECTIONS.userTags, userEmail, opts),
  });
}

/* New: meta variant for pill */
export async function fetchUserTagsOnceWithMeta(userEmail, opts = {}) {
  if (opts?.noCache) {
    const value = await fetchByEmailOnce(COLLECTIONS.userTags, userEmail, opts);
    return { value, fromCache: false };
  }
  const key = `tags:${userEmail}`;
  return getOrFetchWithMeta({
    key,
    ttlMs: opts.ttlMs ?? TTL_USER_TAGS,
    persist: true,
    persistKey: key,
    fetcher: () => fetchByEmailOnce(COLLECTIONS.userTags, userEmail, opts),
  });
}

/* ---------- Cache Invalidator ---------- */
export function invalidateUserTagsCache(userEmail) {
  _invalidate(`tags:${userEmail}`);
}
